import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

type MoleculeProps = {
  object: {
    x: number,
    y: number,
    width: number,
    height: number,
    transcription: string,
  },
};

const Molecule: React.FC<MoleculeProps> = ({ object }) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const [tooltipHovered, setTooltipHovered] = useState<boolean>(false);
  const [copied, setCopied] = useState<boolean>(false);

  const truncateSmiles = (smiles: string, maxLen: number = 24): string => {
    if (!smiles) return "";
    return smiles.length > maxLen ? smiles.substring(0, maxLen) + "..." : smiles;
  };

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (object.transcription) {
      await navigator.clipboard.writeText(object.transcription);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  const showTooltip = hovered || tooltipHovered;

  return (
    <div
      className="absolute box-border pointer-events-auto z-10 bg-blue-400/30"
      style={{
        left: `${object.x}px`,
        top: `${object.y}px`,
        width: `${object.width}px`,
        height: `${object.height}px`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {showTooltip && object.transcription && (
        <div
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 z-20
                     bg-white border border-gray-300 rounded shadow-md
                     flex items-center gap-1 p-1
                     after:content-[''] after:absolute after:top-full after:left-0 after:w-full after:h-2"
          style={{ width: '200px' }}
          onMouseEnter={() => setTooltipHovered(true)}
          onMouseLeave={() => setTooltipHovered(false)}
        >
          <div 
            className="flex-1 text-xs font-mono text-gray-700 truncate px-1"
            title={object.transcription}
          >
            {truncateSmiles(object.transcription)}
          </div>
          <button
            onClick={handleCopy}
            className="p-1 hover:bg-gray-100 rounded transition-colors flex-shrink-0"
            title="Copy SMILES"
          >
            {copied ? (
              <Check size={14} className="text-green-600" />
            ) : (
              <Copy size={14} className="text-gray-500" />
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default Molecule;
